import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import WorkReportDocumentsApi from '@/services/apiServiceModules/workReportDocumentsApi.js'
const workReportDocumentsApi = new WorkReportDocumentsApi()

export default class WorkReportDocumentsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORK_REPORT_DOCUMENTS, workReportDocumentsApi, {
			useCache: true,
		})
	}
}
